import React, { useEffect, useState } from "react";
import {
  getNumberInputValue,
  getNumberOrUndefinedFromString,
} from "../../../../utils/inputUtils";
import InputTextApollo from "../../../inputs/InputTextApollo";
import ProductWidgetContainer from "./ProductWidgetContainer";
import { Switch, FormControlLabel} from "@material-ui/core";

const GenericUsersProductWidget = ({
  product,
  onRemove,
  onProductChange,
  defaultConcurrentUsers,
  showDetails,
  clusterProfile,
}: {
  product: ProductOptionInterface;
  onRemove: () => void;
  onProductChange: (updatedProduct: ProductOptionInterface) => void;
  defaultConcurrentUsers?: number;
  showDetails: boolean;
  clusterProfile: string;
}) => {

  const [profile, setProfile] = useState(product.profile || clusterProfile);
  useEffect(() => {
    if (typeof defaultConcurrentUsers === "number") {
      const productCopy = { ...product };
      productCopy.properties = { ...productCopy.properties };
      productCopy.properties.concurrentUsers = defaultConcurrentUsers;
      onProductChange(productCopy);
    }
    // Only want this on mount
    // eslint-disable-next-line
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e?.currentTarget || {};
    if (product?.properties && name) {
      const productCopy = { ...product };
      productCopy.properties = { ...productCopy.properties };
      productCopy.properties[name] = getNumberOrUndefinedFromString(value);
      onProductChange(productCopy);
    }
  };

  const handleProfileChange = (newProfile: string) => {
    const productCopy = { ...product, profile: newProfile };
    onProductChange(productCopy);
  };


  console.log(clusterProfile)

  return (
    <ProductWidgetContainer
      onRemove={onRemove}
      title={product?.name}
      productKey={product.key}
      canBeRemoved={product?.canBeRemoved}
      showDetails={showDetails}
      productProfile={product.profile}
      clusterProfile={clusterProfile}
      onProfileChange={handleProfileChange}
     >
      <InputTextApollo
        label="Concurrent Users"
        variant="outlined"
        inputProps={{ type: "number" }}
        InputProps={{
          name: "concurrentUsers",
          value: getNumberInputValue(
            product?.properties?.concurrentUsers || ""
          ),
          onChange: handleInputChange,
        }}
      />
    </ProductWidgetContainer>
  );
};

export default GenericUsersProductWidget;
